import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { Close } from '@mui/icons-material';
import { Box, Link, SwipeableDrawer } from '@mui/material';
import cx from 'classnames';

import routePages from 'routes/routes';

import './Header.scss';

const Header = ({ isOnTop = true }) => {
    const { t, i18n } = useTranslation();
    const location = useLocation();

    const [menuOpen, setMenuOpen] = useState(false);
    const [pageName, setPageName] = useState('/');

    useEffect(() => {
        Object.keys(routePages).map((routeKey) => {
            const { path, title } = routePages[routeKey];
            if (path === location.pathname) {
                return setPageName(title);
            } else {
                return null;
            }
        });
    }, [location.pathname]);

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        localStorage.setItem('i18nextLng', lng);
    };

    const handleMenuToggle = () => {
        setMenuOpen(!menuOpen);
    };

    return (
        <Box className={cx(['header', { notOnTop: !isOnTop }])}>
            <Box className="menuWrapper">
                <Box className="menuBtn" onClick={handleMenuToggle}>
                    <Box className="line" component="span" />
                    <Box className="line" component="span" />
                    <Box className="line" component="span" />
                </Box>
                <Box className="menuBreadcrumb" onClick={handleMenuToggle}>
                    <span className="menu">{t('common.menu')}</span>
                    <Box className="arrowRight" component="span" />
                    <span className="pageItem">{t(pageName)}</span>
                </Box>
            </Box>
            <Box className="logo">
                {isOnTop ? (
                    <img
                        src={
                            process.env.PUBLIC_URL +
                            process.env.REACT_APP_LOGO_PATH
                        }
                        alt="uEnjoy logo"
                    />
                ) : (
                    <img
                        src={
                            process.env.PUBLIC_URL +
                            process.env.REACT_APP_BRAND_LOGO_PATH
                        }
                        alt="uEnjoy logo"
                    />
                )}
            </Box>
            <SwipeableDrawer
                anchor="bottom"
                variant="temporary"
                open={menuOpen}
                onOpen={handleMenuToggle}
                onClose={handleMenuToggle}
                ModalProps={{
                    keepMounted: true
                }}
                className="menuDrawer">
                <Box className="drawerHeader">
                    <Close
                        className="drawerCloseBtn"
                        onClick={handleMenuToggle}
                    />
                    <Box className="language">
                        {/* {t('common.language.title')} */}
                        <Box className="arrowRight" component="span" />
                        <Box className="langList">
                            <Box
                                className="langItem"
                                onClick={() => changeLanguage('zh-CN')}>
                                {t('common.language.sc')}
                            </Box>
                            <Box className="divider" />
                            <Box
                                className="langItem"
                                onClick={() => changeLanguage('en-US')}>
                                {t('common.language.en')}
                            </Box>
                        </Box>
                    </Box>
                    <Box className="logo">
                        <img
                            src={
                                process.env.PUBLIC_URL +
                                process.env.REACT_APP_LOGO_PATH
                            }
                            alt="uEnjoy logo"
                        />
                    </Box>
                </Box>
                <Box className="menuList">
                    {Object.keys(routePages).map((routeKey) => {
                        const { path, title, isOnMenu } = routePages[routeKey];

                        if (isOnMenu) {
                            return (
                                <Link href={path} key={path}>
                                    {t(title)}
                                </Link>
                            );
                        } else {
                            return null;
                        }
                    })}
                </Box>
                <Box className="drawerFooter">
                    <Box className="policy">
                        <Box className="policyList">
                            <Link href="/privacy-policy" underline="none">
                                <span className="policyItem">
                                    {t('common.navbar.privacyPolicy.title')}
                                </span>
                            </Link>
                            <Box className="divider" />
                            <Link href="/aml-policy" underline="none">
                                <span className="policyItem">
                                    {t('common.navbar.amlPolicy.title')}
                                </span>
                            </Link>
                            <Box className="divider" />
                            <Link href="/antifraud-policy" underline="none">
                                <span className="policyItem">
                                    {t('common.navbar.antiFraudPolicy.title')}
                                </span>
                            </Link>
                        </Box>
                    </Box>
                </Box>
            </SwipeableDrawer>
        </Box>
    );
};

export default Header;
